var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 115,
    viewBox: "0 0 121 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.27 71.8421V25.9474C106.27 15.1277 106.27 9.72358 102.909 6.36179C99.5469 3 94.1428 3 83.3231 3H37.4283C26.6086 3 21.2045 3 17.8428 6.36179C14.481 9.72358 14.481 15.1277 14.481 25.9474V71.8421M11.6011 77.665L14.5957 71.8421H105.995L109.15 77.665C117.429 92.9365 119.494 100.572 116.344 106.286C113.195 112 104.859 112 88.1764 112H32.575C15.8865 112 7.54512 112 4.40133 106.286C1.2518 100.572 3.31707 92.9365 11.6011 77.665Z",
    stroke: "#062F85",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4546 28.8159L85.7325 33.3653C87.9526 35.2756 89.0598 36.2337 89.0598 37.4212C89.0598 38.6087 87.9526 39.5668 85.7325 41.4772L80.4546 46.0265M40.2967 28.8159L35.0188 33.3653C32.7986 35.2756 31.6914 36.2337 31.6914 37.4212C31.6914 38.6087 32.7986 39.5668 35.0188 41.4772L40.2967 46.0265M66.1125 23.0791L54.6388 51.7633",
    stroke: "#062F85",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeDev);
export default __webpack_public_path__ + "static/media/fe-dev.64a8329c3dfa7167d80ab89c5836313b.svg";
export { ForwardRef as ReactComponent };